import { object, bool, string } from '~utils/validation';

export default object({
  maritalStatus: string().required('O campo é obrigatório.'),
  communityPropertyRegime: string().when('maritalStatus', {
    is: (maritalStatus: string) => maritalStatus === 'married',
    then: string().required('O campo é obrigatório.'),
  }),
});
